import styled, { css } from 'styled-components';
import { TextField } from '@mui/material';
import { ifProp, switchProp } from 'styled-tools';
import { COLOR } from '../theme/colors';
export const AppTextField = styled(TextField) `
  .Mui-disabled {
    fieldset {
      border-color: ${COLOR.textColor.tertiary} !important;
    }
  }
  .app-input {
    background-color: ${COLOR.commonColor.white};
  }

  .MuiIconButton-root {
    padding: 0;
  }

  ${ifProp('success', `
      .app-helper-text,
      .app-label-input.MuiFormLabel-root.Mui-focused,
      .app-label-input {
        color: ${COLOR.commonColor.green};
      }

      .app-input,
      .app-input:hover {
        fieldset {
          border-color: ${COLOR.commonColor.green} !important;
        }
      }
    `)};

  ${ifProp('warning', `
      .app-helper-text,
      .app-label-input.MuiFormLabel-root.Mui-focused,
      .app-label-input {
        color: ${COLOR.commonColor.yellow};
      }

      .app-input,
      .app-input:hover {
        fieldset {
          border-color: ${COLOR.commonColor.yellow} !important;
        }
      }
    `)};

  ${switchProp('size', {
    small: css `
      .app-input {
        height: ${ifProp('multiline', 'auto', '32px')};
        padding: 4px 12px 4px 16px;
        line-height: 24px;
        input,
        textarea {
          padding: 0 !important;
          font-size: 14px;
          letter-spacing: 0.15px;
          color: ${COLOR.textColor.primary};
        }
      }

      .app-label-input {
        &[data-shrink='false'] {
          line-height: 24px;
          transform: translate(16px, 6px) scale(0.875);
        }
      }
    `,
    medium: css `
      .app-input {
        height: ${ifProp('multiline', 'auto', '42px')};
        padding: 8px 12px 8px 16px;
        line-height: 24px;
        input,
        textarea {
          padding: 0 !important;
          font-size: 16px;
          letter-spacing: 0.15px;
          color: ${COLOR.textColor.primary};
        }
      }

      .app-label-input {
        &[data-shrink='false'] {
          line-height: 24px;
          transform: translate(16px, 10px) scale(1);
        }
      }
    `,
    large: css `
      .app-input {
        height: ${ifProp('multiline', 'auto', '56px')};
        padding: 16px 16px 12px;
        line-height: 24px;
        input,
        textarea {
          padding: 0 !important;
          font-size: 16px;
          letter-spacing: 0.15px;
          color: ${COLOR.textColor.primary};
        }
      }

      .app-label-input {
        &[data-shrink='false'] {
          line-height: 24px;
          transform: translate(16px, 16px) scale(1);
        }
      }
    `,
})};
`;
